import Routes from './routes';
import GlobalStyle from './styles/GlobalStyle';

function App() {
  return (
    <div className="App">
      <GlobalStyle/>
      <Routes/>
    </div>
  );
}

export default App;
